import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

export default class NewsHighlightsPopup {
    constructor(root) {
        this.root = root;
        this.panel = this.root.querySelector('[data-highlights-panel]');
        this.closeButtons = this.root.querySelectorAll('[data-highlights-close]');
        this.reopenButton = document.querySelector('[data-highlights-reopen]');
        this.swiperEl = this.root.querySelector('.highlights-swiper');
        this.init();
    }

    init() {
        this.closeButtons.forEach((button) => {
            button.addEventListener('click', () => this.close());
        });
        if (this.reopenButton) {
            this.reopenButton.addEventListener('click', () => this.reopen());
        }
        this.initSwiper();
        this.boot();
    }

    initSwiper() {
        if (!this.swiperEl) {
            return;
        }

        new Swiper(this.swiperEl, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                640: { slidesPerView: 2, spaceBetween: 16 },
                768: { slidesPerView: 3, spaceBetween: 16 },
            },
            navigation: {
                nextEl: this.root.querySelector('.highlights-swiper-next'),
                prevEl: this.root.querySelector('.highlights-swiper-prev'),
            },
        });
    }

    boot() {
        this.show();
    }

    show() {
        if (this.panel) {
            this.panel.classList.remove('hidden');
            this.panel.classList.add('flex');
        }
        this.hideReopenButton();
    }

    close() {
        if (this.panel) {
            this.panel.classList.add('hidden');
            this.panel.classList.remove('flex');
        }
        this.showReopenButton();
    }

    reopen() {
        this.show();
    }

    hideReopenButton() {
        if (this.reopenButton) {
            this.reopenButton.classList.add('hidden');
            this.reopenButton.classList.remove('flex');
        }
    }

    showReopenButton() {
        if (this.reopenButton) {
            this.reopenButton.classList.remove('hidden');
            this.reopenButton.classList.add('flex');
        }
    }
}

document.querySelectorAll('.components-block-news-highlights-popup').forEach((block) => {
    new NewsHighlightsPopup(block);
});
